import React, { PureComponent } from "react";

export default class PW extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.337"
      >
        <g transform="translate(0 -85.331)">
          <rect
            width="512"
            height="341.337"
            transform="translate(0 85.331)"
            fill="#338af3"
          />
          <circle
            cx="74.207"
            cy="74.207"
            r="74.207"
            transform="translate(144.695 181.787)"
            fill="#ffda44"
          />
        </g>
      </svg>
    );
  }
}
